import { calculateTotalPriceByType } from 'gentian-pricing-package';

export type PricingType = 'default' | 'resellers' | 'truesage' | 'truesageResellers';

const calculateTrueSagePrice = (area: number): number => {
  if (area <= 0) return 0;
  if (area <= 1) return 200 * area;
  if (area <= 10) return 200 + 65 * (area - 1);
  if (area <= 30) return 785 + 16 * (area - 10);
  if (area <= 100) return 1105 + 13.5 * (area - 30);
  if (area <= 500) return 2050 + 8.5 * (area - 100);
  if (area <= 1000) return 5450 + 6 * (area - 500);
  if (area <= 10000) return 8450 + 4 * (area - 1000);
  if (area <= 12000) return 44450 + 3 * (area - 10000);
  return 50450 + 3 * (area - 12000);
};

export const calculatePriceByType = (area: number, type: PricingType): number => {
  if (type === 'truesage') return calculateTrueSagePrice(area);
  if (type === 'truesageResellers') return calculateTrueSagePrice(area) * 0.9;
  return calculateTotalPriceByType(area, type);
};
